// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEdit_root__3yhUl"};